import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "w-full fixed bottom-6 right-0 flex justify-center items-center z-50"
}
const _hoisted_3 = { class: "flex items-center gap-x-2" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text-sm font-medium" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#C2412D"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L9.7 15.36C9.56 15.51 9.36 15.58 9.17 15.58Z",
    fill: "#C2412D"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58Z",
    fill: "#C2412D"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#1CB030"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L9.7 15.36C9.56 15.51 9.36 15.58 9.17 15.58Z",
    fill: "#1CB030"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58Z",
    fill: "#1CB030"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]

interface Props {
    styleMessage: string
    icon: string
    msg: string
    alt?: string
    status: Boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'messageCard',
  props: {
    styleMessage: null,
    icon: null,
    msg: null,
    alt: null,
    status: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close', payload: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    styleMessage: string
    icon: string
    msg: string
    alt?: string
    status: Boolean
};







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(__props.styleMessage)
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: require('@/assets/image/png/' + __props.icon),
                    alt: __props.alt,
                    class: "w-7"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(__props.msg), 1)
                ]),
                _createElementVNode("div", null, [
                  (__props.styleMessage == 'message-error')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "w-6 h-6",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                      }, _hoisted_7))
                    : _createCommentVNode("", true),
                  (__props.styleMessage == 'message-success')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "w-6 h-6",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                      }, _hoisted_9))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})